import type { CartProduct } from "../models";

export const hasProductUpsellPackages = (standardProduct: CartProduct | undefined) => {
  return (standardProduct?.upsellBloodTestPackageUuids?.length ?? 0) > 0;
};
